import axiosInstance from '@/store/axios';
import { rejectErrorApiV2 } from '@/store/helper';

export default {
  namespaced: true,
  state: {
    watchFolders: [],
  },
  getters: {
    getWatchFolders(state) {
      return state.watchFolders;
    },
  },
  mutations: {
    setWatchFolders(state, watchFolders) {
      state.watchFolders = watchFolders;
    },
  },
  actions: {
    getWatchFolders({ commit }) {
      const params = {};
      return axiosInstance.get('/api/2/watch-folders', { params })
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApiV2(result);
          }
          commit('setWatchFolders', result.data.folders);
          return result.data.folders;
        })
        .catch(error => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    getWatchFolderById({ commit }, id) {
      return axiosInstance.get(`/api/2/watch-folders/${id}`)
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApiV2(result);
          }
          return result.data.folder;
        })
        .catch(error => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    createWatchFolder({ commit }, wf) {
      return axiosInstance({
        method: 'POST',
        url: '/api/2/watch-folders',
        data: wf,
      })
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApiV2(result);
          }
          return result.data.folder;
        })
        .catch(error => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    deleteWatchFolder({ commit }, id) {
      return axiosInstance({
        method: 'DELETE',
        url: `/api/2/watch-folders/${id}`,
      })
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApiV2(result);
          }
          return result.data;
        })
        .catch(error => Promise.reject(error));
    },
  },
};
